import { ReactNode } from "react";

import styles from "./RowNumber.module.scss";

type Props = {
  children: ReactNode;
};

export default function RowNumber({ children }: Props) {
  return (
    <div className={styles.number} data-notranslate>
      {children}
    </div>
  );
}
